<div class="line-attachments">

  <div class="rows">
    <div class="row" *ngFor="let line of lines; let i = index; trackBy: trackById">

      <nz-form-control>
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
          <input nz-input [(ngModel)]="line.value" #attachmentInput readonly hidden />
          <input nz-input [value]="attachmentInput.value | attachmentSlice" type="text" readonly />
        </nz-input-group>

        <div *ngIf="line.isImage && isPreviewableImage(line.value)" class="thumbnail-wrapper">
          <img class="thumbnail-img" [src]="baseUrl + 'media/PreviewFile?path=' + line.value + '&' + urlSuffix" />
        </div>

        <div *ngIf="!isPreviewableImage(line.value) && line.value" class="file-placeholder">
          <i nz-icon nzType="file-text" nzTheme="outline"></i>
        </div>

        <ng-template #suffixIconButton>
          <nz-button-group *ngIf="!readOnly">
            <button *ngIf="line.value !== ''" nz-button nzType="default" nzSearch (click)="clearAttachment(i)">
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </button>

            <button nz-button nzType="default" nzSearch (click)="preview(i)">
              <i nz-icon nzType="eye" nzTheme="outline"></i>
            </button>

            <button nz-button nzType="default" nzSearch (click)="openDrawer(i)">
              <i nz-icon nzType="upload" nzTheme="outline"></i>
            </button>

            <button nz-button nzType="default" nzSearch (click)="removeLine(i)" *ngIf="lines.length > 1">
              <i nz-icon nzType="minus" nzTheme="outline"></i>
            </button>
          </nz-button-group>

          <nz-button-group *ngIf="readOnly">
            <button nz-button nzType="default" nzSearch (click)="preview(i)">
              <i nz-icon nzType="eye" nzTheme="outline"></i>
            </button>
          </nz-button-group>
        </ng-template>
      </nz-form-control>

    </div>
  </div>

  <div class="actions" *ngIf="!readOnly">
    <button nz-button nzType="dashed" (click)="addLine()">
      <i nz-icon nzType="plus" nzTheme="outline"></i>
      Add line
    </button>

    <span class="spacer"></span>

    <button nz-button nzType="default" (click)="cancel()">Cancel</button>
    <button nz-button nzType="primary" (click)="submit()">Submit</button>
  </div>

  <nz-drawer nzPlacement="bottom" [nzTitle]="'Choose Media' | locale" nzHeight="650px"
    [nzVisible]="isAttachmentDrawerVisible" (nzOnClose)="isAttachmentDrawerVisible = false">

    <app-media-container *ngIf="isAttachmentDrawerVisible" [isImage]="activeLine ? activeLine.isImage : false"
      [allowUploadFile]="activeLine ? activeLine.allowUploadFile : true"
      [allowSignature]="activeLine ? activeLine.allowSignature : false"
      [allowUsingCamera]="activeLine ? activeLine.allowUsingCamera : false" (fileUploaded)="onFileUploaded($event)">
    </app-media-container>

  </nz-drawer>

</div>
